/**
 * PC 用の並べ方の再生バー（Issue #470）。盤面の下に**常に出ている**（再生タブの中身を 1 行にしたもの。タブを行き来しない）。
 * 開始位置と先攻はここに置かない（開始前は応答のパネルが PreStartPanel になる）。キーの説明は pcKeys の表から。
 * ライブ映像（?live=1。Issue #617）のときは「ライブへ」（LiveButton）も出す。
 */
import { fmtTime } from './PlaybackTab';
import { keymapHelp } from './pcKeys';
import LiveButton from './LiveButton';

const b = (primary = false) => ({
  minHeight: 34, minWidth: 40, padding: '4px 10px', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#e8eefc', whiteSpace: 'nowrap', flexShrink: 0,
  border: `1px solid ${primary ? '#4fc3ff' : '#345'}`, background: primary ? '#1b4a6d' : '#151c30',
});

export default function TransportBar({ time = { t: 0, d: 0, paused: true }, hasVideo = false, hasPrev = false, hasNext = false, lastMs = null, live = null,
  onBack, onPlayPause, onSeek, onSkip, onPrev, onNext }) {
  const d = Number.isFinite(time.d) && time.d > 0 ? time.d : 0;
  return (
    <div data-testid="transport-bar" style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '6px 10px', borderTop: '1px solid #1c2440', background: '#0a0f1e', flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontVariantNumeric: 'tabular-nums', fontSize: 13 }}>
        {onBack ? <button type="button" aria-label="戻る" style={{ ...b(), border: 'none', background: 'none', color: '#8896b3', fontSize: 18 }} onClick={onBack}>←</button> : null}
        <button type="button" data-testid="transport-toggle" style={{ ...b(true), fontSize: 16, minWidth: 52 }} disabled={!hasVideo} onClick={onPlayPause} aria-label={time.paused ? '再生' : '一時停止'}>{time.paused ? '▶' : '❚❚'}</button>
        <button type="button" style={b()} disabled={!hasVideo} onClick={() => onSkip?.(-5)} aria-label="5 秒戻す">−5s</button>
        <button type="button" style={b()} disabled={!hasVideo} onClick={() => onSkip?.(-1)} aria-label="1 秒戻す">−1s</button>
        <button type="button" style={b()} disabled={!hasVideo} onClick={() => onSkip?.(1)} aria-label="1 秒進める">+1s</button>
        <button type="button" style={b()} disabled={!hasVideo} onClick={() => onSkip?.(5)} aria-label="5 秒進める">+5s</button>
        <span>{fmtTime(time.t)}</span>
        <input type="range" aria-label="シーク" min={0} max={d || 1} step={0.1} value={Math.min(time.t || 0, d || 1)} disabled={!hasVideo}
          onChange={(e) => onSeek?.(Number(e.target.value) * 1000)} style={{ flex: 1, minWidth: 60 }} />
        <span style={{ opacity: 0.75 }}>{fmtTime(d)}</span>
        <LiveButton live={live} style={b()} />
        <button type="button" style={b()} disabled={!hasVideo || !hasPrev} onClick={onPrev}>◀ 発話</button>
        <button type="button" style={b()} disabled={!hasVideo || !hasNext} onClick={onNext}>発話 ▶</button>
        <button type="button" data-testid="transport-last" style={b()} disabled={!hasVideo || lastMs == null} onClick={() => onSeek?.(lastMs)}>最後の応答へ</button>
      </div>
      <div data-testid="transport-keys" style={{ fontSize: 11, color: '#5d6b88', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{keymapHelp()}</div>
    </div>
  );
}
